module.exports = __webpack_public_path__ + "fonts/63a74598-733c-4d0c-bd91-b01bffcd6e69.f828f3c.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/63a74598-733c-4d0c-bd91-b01bffcd6e69.ttf
// module id = 176
// module chunks = 245 246